import { createReducer, on } from "@ngrx/store";
import { IInstallationState } from "./interfaces/installation-state.interface";
import { InstallationActions } from "./installation-state.actions";
import { getActiveInstallationDetailsFailedHandler, getActiveInstallationDetailsSuccessHandler, getLatestInstallationFailedHandler, getLatestInstallationSuccessHandler, setProductConfigurationHeadersHandler } from "./installation-state.reducers-handlers";

export const initialInstallationState: IInstallationState = {
    latestInstallations: undefined,
    latestInstallationsIsLoading: undefined,
    latestInstallationsFailedError: undefined,
    activeInstallationDetails: undefined,
    activeInstallationDetailsFailedError: undefined,
    selectedTopGroup: undefined,
}

export const installationStateReducer = createReducer(
    initialInstallationState,
    // Latest installations
    on(InstallationActions.getLatestInstallations, (state) => ({ ...state, latestInstallationsFailedError: undefined, latestInstallationsIsLoading: true })),
    on(InstallationActions.getLatestInstallationsSuccess, getLatestInstallationSuccessHandler),
    on(InstallationActions.getLatestInstallationsFailed, getLatestInstallationFailedHandler),
    on(InstallationActions.addLatestInstallation, (state, action) => ({ ...state })),
    on(InstallationActions.addLatestInstallationSuccess, (state, action) => ({ ...state, latestInstallations: action.installations })),
    // Installation Details
    // The details on screen are set aside rather than lost: a failed switch puts them back
    // (getActiveInstallationDetailsFailedHandler). Cleared all the same, so nothing waits on the wrong installation.
    on(InstallationActions.getActiveInstallationDetails, (state) => ({
        ...state,
        replacedActiveInstallationDetails: state.activeInstallationDetails ?? state.replacedActiveInstallationDetails,
        replacedActiveInstallationInfo: state.activeInstallationDetails ? state.activeInstallationInfo : state.replacedActiveInstallationInfo,
        activeInstallationDetails: undefined,
        activeInstallationInfo: undefined,
        activeInstallationDetailsFailedError: undefined
    })),
    on(InstallationActions.getActiveInstallationDetailsSuccess, getActiveInstallationDetailsSuccessHandler),
    on(InstallationActions.getActiveInstallationDetailsFailed, getActiveInstallationDetailsFailedHandler),
    // While a details request is pending, the refreshed copy is also what that request puts back if it fails - not
    // the older one it set aside.
    on(InstallationActions.refreshActiveInstallationDetailsSuccess, (state, action) => ({
        ...state,
        activeInstallationDetails: action.installation,
        replacedActiveInstallationDetails: state.replacedActiveInstallationDetails ? action.installation : undefined
    })),
    // Selected top group
    on(InstallationActions.presetSelectedTopGroupRefCode, (state, action) => ({ ...state, selectedTopGroupRefCode: action.selectedTopGroupRefCode })),
    on(InstallationActions.setSelectedTopGroup, (state, action) => ({ ...state, selectedTopGroup: action.selectedTopGroup })),
    on(InstallationActions.resetSelectedTopGroup, (state, action) => ({ ...state, resetSelectedTopGroupRefCode: action.resetSelectedTopGroup?.refCode, resetSelectedTopGroup: action.resetSelectedTopGroup })),
      on(InstallationActions.setProductConfigurationHeaders, setProductConfigurationHeadersHandler),
)